/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const ClockArrowUp = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M13.228 21.925A10 10 0 1 1 21.994 12.338" }],
    ["path", { d: "M12 6v6l1.562.781" }],
    ["path", { d: "m14 18 4-4 4 4" }],
    ["path", { d: "M18 22v-8" }]
  ]
];

export { ClockArrowUp as default };
//# sourceMappingURL=clock-arrow-up.js.map
